// @flow
import React from 'react'
import {useObserver} from 'mobx-react'
import {when, observable} from 'mobx'
import componentStore from 'stores/components'
import Iframe from "react-iframe-comm"
import styled from 'styled-components'
import * as cf from 'cf'
import storybook from 'stores/storybook'
import navStore from 'stores/navbar'

const storybookUrls = {
  'de-DE': 'https://master--wundercurves-de.netlify.app/extensions/storybook',
  'de-AT': 'https://master--wundercurves-com.netlify.app/extensions/storybook'
}

const state = observable({
  mounted: false
})

setTimeout(() => {
  state.mounted = true
  const iframe = document.getElementsByTagName('iframe')[0]
  iframe.contentWindow.postMessage(JSON.stringify({
    id: 'rlx-storybook-select-component'
  }), '*')
}, 1500)

export default function Storybook(){

  React.useEffect(() => {
    when(() => storybook.activeId, () => {
      navStore.setButtonList([
        {
          label: 'Hinzufügen',
          background: 'rgb(0, 150, 136)',
          onClick: () => {
            storybook.save()
            navStore.clearButtonList()
          }
        },{
          label: 'Abbrechen',
          background: 'rgb(233, 30, 99)',
          onClick: () => {
            storybook.clear()
            navStore.clearButtonList()
          }
        }
      ])
    })
  })

  return useObserver(() =>
    <Wrapper visible={!!storybook.activeId || !state.mounted}>
      {console.log('render inner Storybook', state.mounted)}
      <Iframe
        attributes={{
          src: storybookUrls[cf.getLocale()],
          width: "100%",
          height: "100%"
        }}
      />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  visibility: ${props => props.visible ? 'visible' : 'hidden'};
  height: calc(100% - 60px);
  top: 60px;
  left: 0;
  right: 0;
  position: absolute;
  /* width: 1px;
  height:1px;

  ${props => props.visible && `
    width: 100%;
    height: 100%;
  `} */
`


// WEBPACK FOOTER //
// ./src/Storybook.js